export default __webpack_public_path__ + "static/media/next-airdockz.7efb5718.jpg";